import { render, staticRenderFns } from "./RolePermissionForm.vue?vue&type=template&id=69e18baf&"
import script from "./RolePermissionForm.vue?vue&type=script&lang=ts&"
export * from "./RolePermissionForm.vue?vue&type=script&lang=ts&"
import style0 from "./RolePermissionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports